import { render } from "./ShoppableSettings.vue?vue&type=template&id=7db3947c"
import script from "./ShoppableSettings.vue?vue&type=script&lang=js"
export * from "./ShoppableSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__